/**
 * "Read more" toggle for collection descriptions containing the
 * `<!-- more -->` marker (see sections/main-collection-banner.liquid
 * for the split/wrap logic and why this is a content-driven,
 * per-collection opt-in rather than a theme setting - matches
 * production's exact mechanism, just rebuilt in vanilla JS since this
 * theme doesn't ship jQuery the way production's old one does).
 *
 * Deliberately looks up the button/content pair generically (matches
 * any element whose id starts with "CollectionReadMore-") rather than
 * hardcoding a single id, in case more than one collection banner
 * with this marker ever ends up on the same page (not a real scenario
 * today, but costs nothing to not assume otherwise).
 */
(function () {
  document.querySelectorAll('[id^="CollectionReadMore-"]').forEach(function (button) {
    var content = document.getElementById(button.getAttribute('aria-controls'));
    if (!content) return;

    button.addEventListener('click', function () {
      var isHidden = content.hidden;
      content.hidden = !isHidden;
      button.setAttribute('aria-expanded', String(isHidden));
      button.textContent = isHidden
        ? button.getAttribute('data-read-less-text')
        : button.getAttribute('data-read-more-text');
    });
  });
})();
